module.exports = require("@swissquote/crafty-commons/packages/source-map.js");